import { withHandlers } from 'recompose'
import { withOpngoModal } from 'sfproxy/hoc'
import { setActiveLocation } from 'map/actions'
import { isActiveSelector, placeOfInterestSelector } from 'map/selectors'
import Pin from '@components/Pin'
import Popover from 'map/components/popover/POIPopover'

const POIMarker = ({ onClickPin, active, placeOfInterest: { name, image, id, poiType }, style }) => (
    <div style={style}>
        {active && <Popover name={name} id={id} image={image} />}
        <Pin type={poiType} active={active} onClick={onClickPin} name={name} />
    </div>
)

export default compose(
    connect(
        createStructuredSelector({
            active: isActiveSelector,
            placeOfInterest: placeOfInterestSelector,
        }),
        { setActiveLocation }
    ),
    withOpngoModal(),
    withHandlers({
        onClickPin: ({ sfLocationId, setActiveLocation }) => () => setActiveLocation(sfLocationId),
    })
)(POIMarker)
